import pelaporanApi from '../../../services/form/pelaporanApi'

const SET_FORM_PELAPORAN = "SET_FORM_PELAPORAN"

const state = {
	formPelaporan: null,
}

const mutations = {
	[SET_FORM_PELAPORAN](state, data) {
		state.formPelaporan = data
	}
}

const actions = {
	async showFormPelaporan({ getters }, id) {
		let token = getters.getAuthService.token
		return await pelaporanApi.showFormPelaporan(token, id)
	},
	async storeFormPelaporan({ getters }, data) {
		let token = getters.getAuthService.token
		return await pelaporanApi.storeFormPelaporan(token, data)
	},
	async updateFormPelaporan({ getters }, data) {
		let token = getters.getAuthService.token
		return await pelaporanApi.updateFormPelaporan(token, data.id, data.data)
	},
	async storeJenisFormPelaporan({ getters }, data) {
		let token = getters.getAuthService.token
		return await pelaporanApi.storeJenisFormPelaporan(token, data)
	},
	setFormPelaporan({ commit }, data) {
		commit(SET_FORM_PELAPORAN, data)
	},
	async storeFormPelaporanKelahiran({ getters }, data) {
		let token = getters.getAuthService.token
		return await pelaporanApi.storeFormPelaporanKelahiran(token, data)
	},
	async updateFormPelaporanKelahiran({ getters }, data) {
		let token = getters.getAuthService.token
		return await pelaporanApi.updateFormPelaporanKelahiran(token, data.id, data.form)
	},
	async storeFormPelaporanDataOrangTua({ getters }, data) {
		let token = getters.getAuthService.token
		return await pelaporanApi.storeFormPelaporanDataOrangTua(token, data)
	},
	async updateFormPelaporanDataOrangTua({ getters }, data) {
		let token = getters.getAuthService.token
		return await pelaporanApi.updateFormPelaporanDataOrangTua(token, data.id, data.form)
	},
	async storeFormPelaporanPelapor({ getters }, data) {
		let token = getters.getAuthService.token
		return await pelaporanApi.storeFormPelaporanPelapor(token, data)
	},
	async updateFormPelaporanPelapor({ getters }, data) {
		let token = getters.getAuthService.token
		return await pelaporanApi.updateFormPelaporanPelapor(token, data.id, data.form)
	},
	async storeFormPelaporanSaksi({ getters }, data) {
		let token = getters.getAuthService.token
		return await pelaporanApi.storeFormPelaporanSaksi(token, data)
	},
	async updateFormPelaporanSaksi({ getters }, data) {
		let token = getters.getAuthService.token
		return await pelaporanApi.updateFormPelaporanSaksi(token, data.id, data.form)
	},
	async storeFormPelaporanLahirMati({ getters }, data) {
		let token = getters.getAuthService.token
		return await pelaporanApi.storeFormPelaporanLahirMati(token, data)
	},
	async updateFormPelaporanLahirMati({ getters }, data) {
		let token = getters.getAuthService.token
		return await pelaporanApi.updateFormPelaporanLahirMati(token, data.id, data.form)
	},
	async storeFormPelaporanKematian({ getters }, data) {
		let token = getters.getAuthService.token
		return await pelaporanApi.storeFormPelaporanKematian(token, data)
	},
	async updateFormPelaporanKematian({ getters }, data) {
		let token = getters.getAuthService.token
		return await pelaporanApi.updateFormPelaporanKematian(token, data.id, data.form)
	},
	async storeFormPelaporanPerkawinan({ getters }, data) {
		let token = getters.getAuthService.token
		return await pelaporanApi.storeFormPelaporanPerkawinan(token, data)
	},
	async updateFormPelaporanPerkawinan({ getters }, data) {
		let token = getters.getAuthService.token
		return await pelaporanApi.updateFormPelaporanPerkawinan(token, data.id, data.form)
	},
	async storeFormPelaporanPerceraian({ getters }, data) {
		let token = getters.getAuthService.token
		return await pelaporanApi.storeFormPelaporanPerceraian(token, data)
	},
	async storeFormPelaporanCapilLuarNkri({ getters }, data) {
		let token = getters.getAuthService.token
		return await pelaporanApi.storeFormPelaporanCapilLuarNkri(token, data)
	},
	async storeFormPelaporanSubjekAktaKesatu({ getters }, data) {
		let token = getters.getAuthService.token
		return await pelaporanApi.storeFormPelaporanSubjekAktaKesatu(token, data)
	},
	async storeFormPelaporanSubjekAktaKedua({ getters }, data) {
		let token = getters.getAuthService.token
		return await pelaporanApi.storeFormPelaporanSubjekAktaKedua(token, data)
	},
	async storeFormPelaporanPembetulanPembatalanAkta({ getters }, data) {
		let token = getters.getAuthService.token
		return await pelaporanApi.storeFormPelaporanPembetulanPembatalanAkta(token, data)
	},
	async storeFormPelaporanPengakuanAnak({ getters }, data) {
		let token = getters.getAuthService.token
		return await pelaporanApi.storeFormPelaporanPengakuanAnak(token, data)
	},
	async storeFormPelaporanPengangkatanAnak({ getters }, data) {
		let token = getters.getAuthService.token
		return await pelaporanApi.storeFormPelaporanPengangkatanAnak(token, data)
	},
	async storeFormPelaporanPengesahanAnak({ getters }, data) {
		let token = getters.getAuthService.token
		return await pelaporanApi.storeFormPelaporanPengesahanAnak(token, data)
	},
	async storeFormPelaporanPeristiwaPenting({ getters }, data) {
		let token = getters.getAuthService.token
		return await pelaporanApi.storeFormPelaporanPeristiwaPenting(token, data)
	},
	async storeFormPelaporanPerubahanNama({ getters }, data) {
		let token = getters.getAuthService.token
		return await pelaporanApi.storeFormPelaporanPerubahanNama(token, data)
	},
	async storeFormPelaporanPerubahanStatusKewarganegaraan({ getters }, data) {
		let token = getters.getAuthService.token
		return await pelaporanApi.storeFormPelaporanPerubahanStatusKewarganegaraan(token, data)
	},
	async cetakFormPelaporan({ getters }, id) {
		let token = getters.getAuthService.token
		return await pelaporanApi.cetakFormPelaporan(token, id)
	}
}

const getters = {
	getFormPelaporan: state => {
		return state.formPelaporan
	}
}

export default {
	state,
	mutations,
	actions,
	getters
}